import type { GenericAbortSignal } from "axios";
import { createInfiniteQuery } from "react-query-kit";

import type { IInfiniteHfParams, IInfiniteHfResponse } from "./types";

import { axiosClient } from "@/api";
import type { IWithInfinite } from "@api/types.ts";
import { getApi } from "@api/apiPath";

const { key, getPath } = getApi("infinite.getAllHFs");

type IResponse = IWithInfinite<IInfiniteHfResponse>;
type IVariables = IInfiniteHfParams;

const getAllInfiniteHFs = async (
  props: IVariables & { cursor: number },
  signal?: GenericAbortSignal,
): Promise<IResponse> => {
  const { data } = await axiosClient.get(getPath(), {
    params: props,
    signal,
  });

  return data.data;
};

export const useGetAllInfiniteHFs = createInfiniteQuery<IResponse, IVariables>({
  primaryKey: `infinite_${key}`,
  queryFn: ({ queryKey: [_primaryKey, variables], pageParam, signal }) =>
    getAllInfiniteHFs({ ...variables, cursor: pageParam }, signal),
  getNextPageParam: (lastPage) => lastPage.nextCursor,
  //   initialPageParam: 1
});
